import { NgxsModule } from '@ngxs/store';
import { NgModule, ModuleWithProviders, inject, provideAppInitializer } from '@angular/core';

const noOpFactory = (handlers: any[] = []) => {
  return (): Promise<void> => {
    handlers.forEach(handler => {
      inject(handler);
    });
    return Promise.resolve();
  };
};

@NgModule({
  imports: [NgxsModule],
})
export class HandlerModule {
  static forRoot(handlers: any[] = []): ModuleWithProviders<HandlerModule> {
    return {
      ngModule: HandlerModule,
      providers: [...handlers, provideAppInitializer(noOpFactory(handlers))],
    };
  }
}
